// 收集packages下所有组件，并按vue插件的格式封装对象，并导出
import Button from './button/button.vue'
const obj = {
  install: function (Vue) {
    console.log('install...')
    Vue.component('MyButton', Button)
  }
}
export default obj
